import { useState, useEffect } from 'react';

export const useChecklist = (storageKey) => {
  const [checkedItems, setCheckedItems] = useState(new Set());

  // Load checked items from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved) {
      try {
        const parsedItems = JSON.parse(saved);
        setCheckedItems(new Set(parsedItems));
      } catch (error) {
        console.error('Error loading checklist state:', error);
      }
    }
  }, [storageKey]);

  // Save checked items to localStorage whenever they change
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify([...checkedItems]));
  }, [checkedItems, storageKey]);

  const handleCheck = (itemId) => {
    setCheckedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(itemId)) {
        newSet.delete(itemId);
      } else {
        newSet.add(itemId);
      }
      return newSet;
    });
  };

  const isChecked = (itemId) => checkedItems.has(itemId);

  const getCheckedCount = (items) => {
    return items.filter(item => checkedItems.has(item.id)).length;
  };

  return {
    checkedItems,
    handleCheck,
    isChecked,
    getCheckedCount
  };
};